import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import fetch from 'node-fetch';

const client = new ApolloClient({
  link: new HttpLink({
    fetch,
    uri: process.env.GATSBY_API_URL,
  }),
  cache: new InMemoryCache()
});

export default client


// WEBPACK FOOTER //
// ./src/client.js